import React, {
    useState,
    useRef,
    useEffect,
    Fragment
} from 'react';
import { Chevron } from "./index";
import styled from "styled-components";

const Wrapper = styled.div`
    background: white;
    width: ${props => props.width};
    order: ${props => props.order};
    padding: ${props => props.padding};

    ${props => props.theme.mediaQueries.medium}{
        width: ${props => props.widthMedium};
    };   

`;

const TabWrapper = styled.div`
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
`;

const HeaderWrapper = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    align-items: center;
    cursor: pointer;
    height: 88px;
    background: ${props => props.background};
    color: ${props => props.color};
    text-align: center;
    padding : 5px;

  
`;

const Description = styled.p`
    font-size: 1.33rem;
    line-height: 24px;
    font-weight: 500;

    ${props => props.theme.mediaQueries.medium}{
        font-size: 0.8rem;
    };
`;

const Line = styled.div`
    width: 100%;
    margin-bottom: 32px;
`

const Content = styled.div`
    height: 100%;
    overflow: hidden;
    margin-top: 0;
    width: 100%;
    margin-left: auto;
    margin-right: auto;

    ${props => props.theme.mediaQueries.medium}{
        padding-left: 16px;
        padding-right: 16px;
    };
`;

const P = styled.p`
    ${props => props.theme.mediaQueries.medium}{
        font-size: 0.7rem;
    };
`

const Tabs = ({
    tabItems
}) => {


    const [isActive, setIsActive] = useState(tabItems.map((item => item.isOpen ? true : false)));

    const toggelAccordionItem = (index) => {

        if (!isActive[index]) {

            isActive[index] = true

            setIsActive([...isActive.map((value, i) => {
                return i === index ? value : false
            })])

        }

    }


    const headerBackground = (index) => {

        return !isActive[index] ? "#FFA500" : "#FFFFFF"

    }

    const headerFontColor = (index) => {

        return !isActive[index] ? "#FFFFFF" : "#2e2e35"

    }

    const contentLoader = (index) => {

        if (isActive[index]) {

            return <Wrapper
                order="3"
                padding = "0 20px"
            >
                <Content>
                    <Line />
                    {tabItems[index].content}
                </Content>
            </Wrapper>
        }

    }



    const renderTabs = (tabItems) => {
        return tabItems.map((item, index) => {
            return (

                <Fragment key={index}>
                    <Wrapper
                        width="calc(50% - 0.5px)"
                        widthMedium="calc(50% - 1px)"
                    >
                        <HeaderWrapper
                            onClick={() => toggelAccordionItem(index)}
                            background={headerBackground(index)}
                            color={headerFontColor(index)}
                        >

                            <Description>
                                {item.description}
                            </Description>
                        </HeaderWrapper>

                    </Wrapper>
                    {contentLoader(index)}

                </Fragment>

            )
        })
    }


    return <TabWrapper> {renderTabs(tabItems)} </TabWrapper>

}

export default Tabs;